import { css, mediaQueries } from '@eti/styles';
import Toast from './Toast';

const toastWrapperStyles = css`
  animation: toast-in-left 0.7s;
  bottom: 84px;
  position: fixed;
  transition: transform 0.6s ease-in;
  z-index: 999;

  @media ${mediaQueries.small.only} {
    bottom: 80px;
  }
`;
interface ToastProps {
  description: string;
  id: number;
}
interface ToastWrapperProps {
  autoCloseDuration?: number;
  deleteToast: (id: number) => void;
  toastList: ToastProps[];
}

const ToastWrapper = ({ autoCloseDuration = 8, deleteToast, toastList }: ToastWrapperProps) => {
  if (!toastList.length) {
    return null;
  }

  return (
    <div className={toastWrapperStyles} data-testid="toast-wrapper" role="region">
      {toastList.map((message: ToastProps) => (
        <Toast
          autoCloseDuration={autoCloseDuration}
          deleteToast={deleteToast}
          description={message.description}
          id={message.id}
          key={message.id}
        />
      ))}
    </div>
  );
};
export default ToastWrapper;
